import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { getTrackingUser } from 'node/map-search/utils/analytics/getTrackingUser';

import { IJsonQuery } from 'shared/common/packages/api-models/common/json_query';
import { IExperiment } from 'shared/map-search/types/experiments';
import { TUser } from 'shared/map-search/types/user';
import { getSiteType } from 'shared/map-search/utils/analytics';

interface ITrackFilterApply {
  jsonQuery: IJsonQuery;
  queryString?: string;
}

export function trackApplyClick({ jsonQuery, queryString }: ITrackFilterApply) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'button_search',
    label: queryString,
    category: 'Map',
    sc: jsonQuery,
  });
}

interface ITrackPageViewParams {
  deviceType: TDevice;
  user: TUser;
  jsonQuery: IJsonQuery;
  regionId?: null | number;
  experiments: IExperiment[];
  mlSearchSessionGuid: string | null;
}

export function trackPageView({
  jsonQuery,
  user,
  deviceType,
  regionId,
  experiments,
  mlSearchSessionGuid,
}: ITrackPageViewParams) {
  ca('pageview', {
    category: 'page',
    action: 'newpage',
    name: 'newpage',
    label: 'open',
    sc: jsonQuery,
    user: getTrackingUser({ user, regionId, experiments }),
    page: {
      pageType: 'Map',
      siteType: getSiteType(deviceType),
      extra: {
        mlSearchSessionGuid,
      },
    },
  });
}
